import OrderAddressSearchComponent from "../order/OrderAddressSearchComponent.tsx";
import {imageMap} from "../../images/imageMap.ts";
import TdcNetFppLogo from "../../images/home/TdcNetFppLogo.tsx";

export default function IdaHeroComponent() {
    return (
        <>
            <div id={'hero-container'} className={'hero-container hero-container--hiperligfiber darkteal tdcnet-fpp'}>
                <div className={'hero-background-wrapper'}>
                    <div className={'hero-background'}/>
                </div>

                <div className={'hero-content'}>
                    <div className={'text'}>
                        <h1>
                            <span className={'hero-speed'}>
                                1000 Mbit
                            </span>
                            <span className={'hero-pre-price'}>
                                fibernet fra kun
                            </span>
                            <span className={'hero-price hero-price--99'}>
                                <span className={'hiper-text-stroke'}>99</span><span className={'price-comma-dash'}>,-</span><span className={'price-md'}>/md.</span>
                            </span>
                        </h1>

                        <div className={'stamp-container'}>
                            <img
                                src={imageMap.home.mvfp_2025}
                                alt={'Hiper vinder Mest Værdi For Pengene for sjette år i træk.'}
                            />
                        </div>

                        <div className={'stamp-container'}>
                            <TdcNetFppLogo/>
                        </div>
                    </div>
                </div>

                <div className={'address-wrap'}>
                    <h2>Se hvilket tilbud du kan få
                        <div className={'scroll-down-arrow'}/>
                    </h2>
                    <OrderAddressSearchComponent/>
                </div>

                <p className={'conditions'}>
                    Inkl. gratis oprettelse og wifi-router.
                    Min. pris efter 6 mdr. fra 594 kr.
                    Pris efter 6 mdr. fra 299 kr./md.
                    Tilbuddet gælder udvalgte adresser på TDC NET fiber.
                    Forudsætter at du ikke har været kunde de seneste 6 mdr.
                </p>
            </div>
        </>
    )
}
